<div class="floori-translation-input">
    <!-- default lang -->
    <ng-container
        *ngTemplateOutlet="
            translationRow;
            context: { $implicit: 'default', label: 'common.default' }
        ">
    </ng-container>

    <!-- other languages -->
    @for (language of sortedLanguages(); track language) { @if (!isCollapsible() || isExpanded()) {
    <ng-container
        *ngTemplateOutlet="
            translationRow;
            context: { $implicit: language, label: 'lang.' + language }
        ">
    </ng-container>
    } }

    <!-- toggle translations -->
    @if (isCollapsible()) {
    <div class="toggle-row">
        <button floori-button class="secondary small" type="button" (click)="toggleExpanded()">
            {{
                isExpanded()
                    ? ("common.showLessTranslations" | flTranslate)
                    : ("common.showMoreTranslations" | flTranslate)
            }}
        </button>
    </div>
    }
</div>

<!-- row template -->
<ng-template #translationRow let-lang let-label="label">
    @if (labelPosition() === "left") {
    <div class="translation-row">
        <span class="language-label">{{ label | flTranslate }}</span>
        <div class="row-fields">
            <ng-container
                *ngTemplateOutlet="
                    inputField;
                    context: { lang: lang, second: false }
                "></ng-container>
            @if (showSecondField()) {
            <ng-container
                *ngTemplateOutlet="
                    inputField;
                    context: { lang: lang, second: true }
                "></ng-container>
            }
        </div>
    </div>
    } @else {
    <div class="row-fields">
        <ng-container
            *ngTemplateOutlet="
                inputField;
                context: { lang: lang, second: false, labelRight: label }
            "></ng-container>
        @if (showSecondField()) {
        <ng-container
            *ngTemplateOutlet="inputField; context: { lang: lang, second: true }"></ng-container>
        }
    </div>
    }
</ng-template>

<!-- input template -->
<ng-template #inputField let-lang="lang" let-second="second" let-labelRight="labelRight">
    <floori-input
        [type]="multiline() ? 'textarea' : 'text'"
        [value]="second ? getSecondTranslationForLanguage(lang) : getTranslationForLanguage(lang)"
        [placeholder]="second ? secondPlaceholder() : placeholder()"
        [disabled]="disabled"
        [readonly]="readonly"
        [required]="required"
        [clear]="false"
        (changed)="second ? updateSecondTranslation(lang, $event) : updateTranslation(lang, $event)"
        (focusChange)="onFocusChange($event)">
        @if (labelRight) {
        <ng-container class="floori-input-appendix">
            <span class="label">{{ labelRight | flTranslate }}</span>
        </ng-container>
        }
    </floori-input>
</ng-template>
